export default __webpack_public_path__ + "static/media/testi12-bg.d5651f50.jpg";